import { render, staticRenderFns } from "./TreeCollapseItem.vue?vue&type=template&id=53fa999f&scoped=true"
import script from "./TreeCollapseItem.vue?vue&type=script&lang=js"
export * from "./TreeCollapseItem.vue?vue&type=script&lang=js"
import style0 from "./TreeCollapseItem.vue?vue&type=style&index=0&id=53fa999f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fa999f",
  null
  
)

export default component.exports